import { useSelector } from './use-selector.js';
import { PieChartState } from '../../types/state.js';

export const useOverlayState = () =>
  useSelector((state: PieChartState) => state.overlay);

export const useHighlightedIdState = () =>
  useSelector((state: PieChartState) => state.highlightedId);

export const useVisibleSlicesState = () =>
  useSelector((state: PieChartState) => state.visibleSlices);
